/**
 *
 * Asynchronously loads the component for GoalPlanner
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GoalPlanner = lazyLoad(
  () => import('./index'),
  module => module.GoalPlanner,
);
